angular.
module("dx.webapp.register", [
	"digiexam.services",
	"digiexam.services.faults",
	"dx.webapp.navigation",
	"dx.webapp.validation",
	"UIStateManager",

	"dx.ui.components.localize",
]);
